import { React, models, kea, history, resources, selectores, Route, match, validation, createSelectorRx, formfields, componentToRx, withRouter } from "app/main/std";
import { observeResource } from "kea-resource";

import { ClienteForm } from "./form";
const ClienteFormRx = componentToRx(ClienteForm);

type Entity = models.ClienteDTO;
const resource = resources.Cliente;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value: Promise<Entity> | Entity;
}

const permisos = resources.User.PermisoRx;
const permisoEditar = resources.User.PermisoRx.map(x => x.Catalogos.Cliente.EditarSeccion);

class ClienteEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue() };
    }
    get id(): number | "new" {
        const id = this.props.match.params.id;
        return id == "new" ? id : Number.parseInt(id);
    }
    async getValue() {
        if (this.id == "new") {
            return { FechaDeInicioParaComisiones: new Date,NumeroPoliza:"",SeguroViaje:true, 
            ImprimirPrecioGuia:true, IdentificacionCliente: {} } as Entity;
        } else {
            return await resource.get(this.id);
        }
    }

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onGuardar = async () => {
        const id = this.id;
        const func = id == "new" ? resource.add : resource.update;
        const value = await this.state.value;
        await func(value);
        history.go("/catalogos/Cliente");
    }

    render() {
        const props = this.props;
        const params = props.match!.params.id;
        return <ClienteFormRx
            nuevo={this.id == "new"}
            value={this.state.value}
            editar={permisoEditar}
            onChange={this.onChange}
            onGuardar={this.onGuardar} />;
    }
}

export const ClienteEdit = withRouter(ClienteEditComp);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/edit.tsx